// UpgradePopup.js
import React, { useState, useEffect, useRef } from "react";
import "../styles/withoutloginpaypal.css";
import { fetchMasterlist, fetchVerifySubscriptionApi, fetchEditSubcriptionUserDetailApi } from "../api/api";


const UpgradePopup = ({ show, handleClose, selectedPlan, setSuccessMessagePrice }) => {
  
  const [fieldErrors, setFieldErrors] = useState({});
  const [countries, setCountries] = useState([]);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const paypalRef = useRef(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;
  // const planId = process.env.REACT_APP_PAYPAL_PLAN_ID;
  const username = sessionStorage.getItem("username");
  // const subscriberid = sessionStorage.getItem("subscriberid");
  const storedLoginData = sessionStorage.getItem("loginData");
  const parsedLoginData = storedLoginData ? JSON.parse(storedLoginData) : {};
  const [formData, setFormData] = useState({
    firstName: parsedLoginData.firstname || "",
    country: parsedLoginData.country || "",
  });



  const handlePopupClose = () => {
    paypalRef.current = null;
    if (handleClose) handleClose();
  };

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const response = await fetchMasterlist();
        if (response && Array.isArray(response.data.countrycodes)) {
          setCountries(response.data.countrycodes);
        } else {
          console.error("Invalid country response:", response);
        }
      } catch (err) {
        console.error("Error fetching countries:", err);
      }
    };

    loadCountries();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFieldErrors((prev) => ({ ...prev, [name]: "" })); // clear error while typing
  };

  const validate = async () => {
    const errors = {};
    if (!formData.country.trim()) errors.country = "Country is required";
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = await validate();
    if (!isValid) return;
    const updatedData = {
    ...parsedLoginData,
    firstname: formData.firstName,
    country: formData.country,
  };

    try {
      const response = await fetchEditSubcriptionUserDetailApi(updatedData);
      if (response.statuscode === 200 || response.success) {
        sessionStorage.setItem("loginData", JSON.stringify(updatedData));
        // setLoginData(updatedData);
        // sessionStorage.setItem("loginData", JSON.stringify(updatedData));
        // setShowPopupPersonal(false);
      } else {
        console.error("Failed to update user details:", response.message || response);
      }
    } catch (err) {
      console.error("Error updating user details:", err);
    }
    // console.log("Form submitted:", formData);
  };


  useEffect(() => {
    if (!show || !selectedPlan) return;

    const renderPaypalButtons = () => {
      if (!paypalRef.current) return;

      window.paypal
        .Buttons({
          fundingSource: window.paypal.FUNDING.PAYPAL,
          style: {
            shape: "rect",
            color: "blue",
            layout: "vertical",
            label: "paypal", 
            height: 45
          },
          funding: { disallowed: [window.paypal.FUNDING.CARD] },
          
          createSubscription: async (data, actions) => {
            const isValid = await validate();
            if (!isValid) {
              throw new Error("Please complete all required fields before continuing.");
            } else {
              setError("");
            }
            const updatedData = {
              ...parsedLoginData,
              firstname: formData.firstName,
              country: formData.country,
            };
            try {
              const response = await fetchEditSubcriptionUserDetailApi(updatedData);
              if (response.statuscode === 200 || response.success) {
                sessionStorage.setItem("loginData", JSON.stringify(updatedData));
              } else {
                console.error("Failed to update user details:", response.message || response);
              }
            } catch (err) {
              console.error("Error updating user details:", err);
            }

            const startTime = parsedLoginData.renewaldate
              ? parsedLoginData.renewaldate
              : null;


            return actions.subscription.create({
              plan_id: selectedPlan.paypalplanid,
              custom_id: username,
              start_time: startTime
            });
          },
          //  payapal login added 
          onApprove: async (data) => {
            try {
              const subscriptionId = data.subscriptionID;
              const previouspaypalsubscriptionid = parsedLoginData.paypalsubscriptionid ? parsedLoginData.paypalsubscriptionid : ''
              const result = await fetchVerifySubscriptionApi(
                subscriptionId,
                username,
                selectedPlan.subscriptionid,
                selectedPlan.productid,
                previouspaypalsubscriptionid,
              );

              // console.log(result)

              if (result.status === "ACTIVE") {
                setSuccessMessagePrice(true)
                setPaymentSuccess(true);
                setSuccessMessage("✅ You’re Pro. Subscription active.");
                handlePopupClose()
              } else {
                setError(`${result.reason}`);
              }
            } catch (err) {
              setError("Payment verification failed.");
            }
          },
          onError: (err) => {
            console.error("PayPal Error:", err);
            let message = "Payment failed. Try again.";
            // if (typeof err === "string") {
            //   message = err;
            // } else if (err?.err) {
            //   message = err.err;
            // } else if (err?.message) {
            //   message = err.message;
            // }
            setError(message);
            setTimeout(() => {
              setError("");
            }, 5000);
          }
        })
        .render(paypalRef.current)
        .then(() => setLoading(false));
    };

    const loadPayPalScript = () => {
      setLoading(true);
      if (document.getElementById("paypal-sdk")) {
        if (window.paypal) renderPaypalButtons();
        return;
      }

      const script = document.createElement("script");
      script.id = "paypal-sdk";
      script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&vault=true&intent=subscription&components=buttons`;
      script.async = true;
      script.onload = () => {
        console.log("PayPal SDK loaded.");
        renderPaypalButtons();
      };
      script.onerror = () => {
        console.error("Failed to load PayPal SDK script.");
        setError("Failed to load PayPal. Check clientId.");
        setLoading(false);
      };

      document.body.appendChild(script);
    };
    
    loadPayPalScript();

    return () => {
      if (paypalRef.current) paypalRef.current.innerHTML = "";
    };
  }, [show, selectedPlan, clientId, username, formData.country]);

  return (
    <div className="upgradelogin-popup-overlay">
      <div className="upgradelogin-popup-container">
        {/* Close Button */}
        <div className="upgradelogin-header">
          <button className="upgradelogin-popup-close" onClick={handlePopupClose}>
            ×
          </button>
        </div>

        <h2 className="upgradelogin-popup-title">
          Pro Upgrade Checkout
        </h2>
        {error && <p className="error-text-paypal" style={{ whiteSpace: "pre-line" }}>{error}</p>}
        {successMessage && <p className="success-text">{successMessage}</p>}

        {/* Form */}
        <form className="upgradelogin-popup-form" onSubmit={handleSubmit}>
          <label>First name (optional)</label>
          <input
            type="text"
            name="firstName"
            placeholder="Your first name"
            value={formData.firstName}
            onChange={handleChange}
          />

          <label>Country of Residence</label>
          <select
            name="country"
            value={formData.country}
            onChange={handleChange}
            className={fieldErrors.country ? "input-error" : ""}
          >
            <option value="">Select your country</option>
            {countries.map((c, idx) => (
              <option key={idx} value={c.country}>
                {c.country}
              </option>
            ))}
          </select>
          {fieldErrors.country && (
            <p className="field-error-upgradelogin">{fieldErrors.country}</p>
          )}
        </form>

        {loading && <div style={{ color: "blue" }}>Loading PayPal...</div>}

        {/* PayPal Button */}
        <div
        ref={paypalRef}
        className="paypal-button-wrapper"
      ></div>

        {paymentSuccess && (
          <p style={{ color: "green", marginTop: "1rem" }}>
            ✅ Your Payment Successful!
          </p>
        )}
      </div>
    </div>
  );
};

export default UpgradePopup;
